import { z } from "zod";
export const uuidSchema = z.uuid();
export const paginationQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(24),
});
export function paginated(item) {
    return z.object({
        items: z.array(item),
        total: z.number().int(),
        page: z.number().int(),
        pageSize: z.number().int(),
    });
}
export const errorResponse = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        /** Campo que falló, derivado de `instancePath`. Solo en errores de validación. */
        field: z.string().optional(),
    }),
});
//# sourceMappingURL=common.js.map